import { IProps } from "config/props";
import { IAuthProvider } from "smarthub-common";
import { FlexAuthProvider, IFlexAuthProviderProps } from "smarthub-providers";

export const appAuth = (props: IProps): IAuthProvider => {
  const authProps: IFlexAuthProviderProps = {
    name: "FlexAnonAuthProvider",
    tokenName: "flex-anon",
    authorityName: "FLEX",
    ttl: 0,
    cache: {
      storage: "session",
      ttl: {
        unit: "min",
        value: 30,
      },
    },
    uri: props.serviceUris.userToken,
  };
  return new FlexAuthProvider(authProps);
};
